
import './../assets/scss/frontend.scss';

import { initGameEngineTabs } from './frontend/tabs';

document.addEventListener('DOMContentLoaded', () => {
    initGameEngineTabs();
});